import { render, staticRenderFns } from "./EffectDirectionMenu.vue?vue&type=template&id=68f04e02&scoped=true&"
import script from "./EffectDirectionMenu.vue?vue&type=script&lang=js&"
export * from "./EffectDirectionMenu.vue?vue&type=script&lang=js&"
import style0 from "./EffectDirectionMenu.vue?vue&type=style&index=0&id=68f04e02&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f04e02",
  null
  
)

export default component.exports